import { Controller } from "@hotwired/stimulus"

// Copies the controller's `source` text to the clipboard and briefly shows
// confirmation feedback in the `button`.
export default class extends Controller {
  static targets = ["source", "button"]

  async copy() {
    const text = this.sourceTarget.value ?? this.sourceTarget.textContent
    try {
      await navigator.clipboard.writeText(text.trim())
      this.flash()
    } catch (_e) {
      // Fallback for insecure contexts / older browsers
      this.sourceTarget.select?.()
      document.execCommand("copy")
      this.flash()
    }
  }

  flash() {
    if (!this.hasButtonTarget) return
    const original = this.buttonTarget.textContent
    this.buttonTarget.textContent = "Copied!"
    setTimeout(() => { this.buttonTarget.textContent = original }, 1500)
  }
}
